const getSubdomain = () => {
  const subdomain = window.location.host.split(".")[1] ? window.location.host.split(".")[0] : "";
  return { isApp: subdomain === "app", subdomain };
};

export default getSubdomain;
